import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Eye, CheckCircle2, Circle, Lock } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { Link } from "react-router-dom";

export function ModuleCard({ module, onToggleComplete, isStudent = true }) {
  const available = module.status === "tersedia";
  const completed = !!module.completed;
  return (
    <Card className="glass-card glass-card-hover group" data-testid={`module-card-${module.id}`}>
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div>
            <span className="text-xs font-mono font-semibold text-primary tracking-wider">{module.code}</span>
            <h3 className="font-heading font-semibold text-base mt-1 leading-tight">{module.title}</h3>
          </div>
          <StatusBadge status={module.status} />
        </div>
        <p className="text-sm text-muted-foreground mt-3 leading-relaxed line-clamp-3">
          {module.description || "This module's content will be uploaded by admin."}
        </p>

        {isStudent && (
          <div className="mt-4 flex items-center gap-2">
            <Button asChild variant={available ? "default" : "outline"} size="sm" disabled={!available} className="flex-1" data-testid={`module-view-${module.id}`}>
              <Link to={available ? `/student/module/${module.id}` : "#"} aria-disabled={!available}>
                {available ? <Eye className="h-3.5 w-3.5" /> : <Lock className="h-3.5 w-3.5" />}
                {available ? "View Module" : "Not Available"}
              </Link>
            </Button>
            {available && (
              <Button
                size="sm"
                variant={completed ? "secondary" : "outline"}
                onClick={() => onToggleComplete?.(module)}
                data-testid={`module-toggle-${module.id}`}
              >
                {completed ? <CheckCircle2 className="h-3.5 w-3.5" /> : <Circle className="h-3.5 w-3.5" />}
                {completed ? "Completed" : "Not Completed"}
              </Button>
            )}
          </div>
        )}

        {isStudent && (
          <div className="mt-3">
            <span className={`text-xs font-medium ${completed ? "text-teal" : "text-muted-foreground"}`}>
              {completed ? "✓ Module completed" : "Not completed"}
            </span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
